/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpecificCustomer
 */
export interface SpecificCustomer {
    /**
     * 
     * @type {string}
     * @memberof SpecificCustomer
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificCustomer
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificCustomer
     */
    email?: string;
}

/**
 * Check if a given object implements the SpecificCustomer interface.
 */
export function instanceOfSpecificCustomer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SpecificCustomerFromJSON(json: any): SpecificCustomer {
    return SpecificCustomerFromJSONTyped(json, false);
}

export function SpecificCustomerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecificCustomer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function SpecificCustomerToJSON(value?: SpecificCustomer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'email': value.email,
    };
}

